import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import { useUiContext } from '../../../contexts/UiContext/hooks/useUiContext.hook';
import { UploadsTray } from '../../../components/UploadsTray';

import { UserMenu } from './UserMenu';
import { Notifications } from './Notifications';

interface Props {
  readonly onDrawerToggle?: () => void;
  readonly variant: 'loggedIn' | 'loggedOff';
}

export const AppBar = ({
  onDrawerToggle: handleDrawerToggle,
  variant,
}: Readonly<Props>) => {
  const { ui } = useUiContext();

  return !ui.isTextEditorFullscreen && !ui.isImageEditorFullscreen ? (
    <MuiAppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
    >
      <Toolbar>
        {!!(variant === 'loggedIn' && handleDrawerToggle) && (
          <IconButton
            aria-label="Ouvrir le menu latéral"
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography component="div" sx={{ flexGrow: 1 }} variant="h6">
          e-SOCNA
        </Typography>
        {variant === 'loggedIn' && (
          <>
            <UploadsTray />
            <Notifications />
            <UserMenu />
          </>
        )}
      </Toolbar>
    </MuiAppBar>
  ) : null;
};
